
import ApiService from '@/services/ApiService'
import store from '@/store/store'
// import swal from 'sweetalert'

export default {
    /**
     * Gets all public warehouses.
     */
    async getWarehouses () {
        let result = await new ApiService().get('public/warehouses')
        if (result && !store.state.warehouse) {
            store.dispatch('setWarehouse', result.Collection[0])
        } else {
            // result = await new ApiService().get('public/warehouses')
            // if (result && !store.state.warehouse) {
            //     store.dispatch('setWarehouse', result.Collection[0])
            // }
            // swal('', 'De magazijnen kon tijdelijk niet worden ingelade.', 'warning')
        }
        return result
    },

    /**
     * Sets the selected warehouse.
     * @param {*} warehouse the new selected warehouse
     */
    setWarehouse (warehouse) {
        store.dispatch('setWarehouse', warehouse)
    },

    /**
     * Gets the selected warehouse
     */
    getWarehouse () {
        return store.state.warehouse
    }
}



// WEBPACK FOOTER //
// ./src/services/WarehouseService.js